import LoginManagementService from '../../imaios-connection-management/login-management-service';

document.addEventListener('DOMContentLoaded', () => {
	const checkbox = document.getElementById('darkmodeSwitch');
	if (checkbox === null) {
		return;
	}

	function enableDarkMode() {
		checkbox.checked = true;
		document.documentElement.setAttribute('data-theme', 'dark');
		localStorage.setItem('isDarkmode', 'true');
	}

	function disableDarkMode() {
		document.documentElement.setAttribute('data-theme', 'light');
		localStorage.setItem('isDarkmode', 'false');
	}

	function updateSourceMedia(isDarkmode) {
		const pictures = document.querySelectorAll('.switch-media-darkmode');
		Array.from(pictures).forEach((e) => {
			let source = e.querySelector('source');
			source.dataset.media = '(prefers-color-scheme: dark)';
			if (isDarkmode) {
				source.media = 'all';
			} else {
				source.media = 'none';
			}
		});
	}

	function updateDarkmode(isDarkMode) {
		if (isDarkMode) {
			enableDarkMode();
		} else {
			disableDarkMode();
		}
		updateSourceMedia(isDarkMode);
	}

	updateDarkmode(localStorage.getItem('isDarkmode') === 'true');

	checkbox.disabled = false;

	checkbox.addEventListener('change', ({ target }) => {
		updateDarkmode(target.checked);
		LoginManagementService.getUserAccess().then(userAccess => {
			let individual_premium = false;
			let group_premium = false;
			let ip_premium = false;

			Object.values(userAccess).forEach(access => {
				if (typeof access.individual_premium !== 'undefined') {
					individual_premium = true;
				}

				if (typeof access.group_premium !== 'undefined') {
					group_premium = true;
				}

				if (typeof access.ip_premium !== 'undefined') {
					ip_premium = true;
				}
			});

			imaios.pubsub.publish('theme-switch', {
				theme: target.checked ? 'dark' : 'light',
				placement: 'theme_switch_top_bar',
				group_premium: group_premium,
				ip_premium: ip_premium,
				individual_premium: individual_premium
			});
		});
	});

	//region responsive
	const mobileMediaQuery = window.matchMedia('(max-width: 991.98px)');

	const switchDiv = document.getElementById('div-darkmode');

	const mobileDiv = document.getElementById('switch-darkomde-mobile');
	const desktopDiv = document.getElementById('switch-darkomde-desktop');

	// Switch input location for responsive
	if (mobileMediaQuery.matches) {
		desktopDiv.removeChild(switchDiv);
		mobileDiv.appendChild(switchDiv);
	}

	mobileMediaQuery.addEventListener('change', mobileMediaQuery => {
		if (mobileMediaQuery.matches) {
			desktopDiv.removeChild(switchDiv);
			mobileDiv.appendChild(switchDiv);
		} else {
			mobileDiv.removeChild(switchDiv);
			desktopDiv.appendChild(switchDiv);
		}
	});
	//endregion
});
